import { Link } from "@inertiajs/react";

export default function MiniCartFooter({ totals, onClose }) {
  return (
    <div className="border-t border-border  p-5">
      <div className="mb-5 flex items-center justify-between">
        <span className="text-sm text-muted-foreground">Subtotal</span>
        <span className="text-xl font-black">
          ৳{totals.subtotal.toLocaleString()}
        </span>
      </div>

      <div className="grid gap-3">
        <Link
          href="/checkout"
          onClick={onClose}
          className="rounded-full border border-border px-5 py-3 text-center text-sm font-black uppercase"
        >
          View Checkout
        </Link>

        <Link
          href="/checkout"
          onClick={onClose}
          className="rounded-full bg-black px-5 py-3 text-center text-sm font-black uppercase text-white"
        >
          Checkout
        </Link>
      </div>
    </div>
  );
}
